<template>
  <custome-Dialog
    :dialog-visible.sync="dialogVisible"
    confirm-text="保存"
    :title="title"
    width="30%"
    :confirm-disable="false"
    @confirm="confirm"
    @close="close"
  >
    <div class="content">
      <el-form
        ref="createForm"
        :model="createForm"
        :rules="creatRules"
        label-width="100px"
      >
        <el-form-item
          label="代理商名称"
          prop="agentId"
        >
          <el-select
            v-model="createForm.agentId"
            placeholder="请选择代理商"
            filterable
            clearable
            @change="()=>{ createForm.agentUserId = null}"
          >
            <el-option
              v-for="agent in agentList"
              :key="agent.id"
              :label="agent.agentName"
              :value="agent.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="代理商人员名称"
          prop="agentUserId"
        >
          <el-select
            v-model="createForm.agentUserId"
            placeholder="请选择代理商人员"
            filterable
            clearable
          >
            <el-option
              v-for="agentUser in agentUserList"
              :key="agentUser.userId"
              :label="agentUser.showName"
              :value="agentUser.userId"
            />
          </el-select>
        </el-form-item>
      </el-form>
    </div>
  </custome-Dialog>
</template>
<script>
import customeDialog from '@/components/common/dialog.vue';
import axClient from '@/services';

export default {
  name: 'AgencyAgent',
  components: { customeDialog },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    item: {
      type: [Object, null],
      default: null,
    },
    agentList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      title: '修改代理商人员',
      cancelText: '取消',
      createForm: {
        agencyId: null,
        agentId: null,
        agentUserId: null,
      },
      creatRules: {
        agentId: [
          { required: true, message: '请选择代理商', trigger: 'blur' },
        ],
        agentUserId: [
          { required: true, message: '请选择代理商用户', trigger: 'blur' },
        ],
      },
    };
  },
  computed: {
    agentUserList() {
      if (this.createForm.agentId) {
        if (this.agentList.filter((v) => v.id === this.createForm.agentId).length > 0) {
          return this.agentList.filter((v) => v.id === this.createForm.agentId)[0].userList;
        }
      }
      return [];
    },
  },
  watch: {
    item(val) {
      if (val) {
        const {
          agentId,
          agentUserId,
          id,
        } = val;
        this.createForm = {
          agentId,
          agentUserId,
          agencyId: id,
        };
      }
    },
    dialogVisible(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.createForm.clearValidate();
        });
      }
    },
  },
  methods: {
    close() {
      this.$emit('update:dialogVisible', false);
      this.$emit('close');
    },
    confirm() {
      this.$refs.createForm.validate(async (valid) => {
        if (valid) {
          const data = await axClient.agency.upsertAgent(this.createForm);
          if (!data) return;
          this.$message.success('修改代理商成功');
          this.$emit('update:dialogVisible', false);
          this.$emit('confirm');
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  min-height: 200px;
  .wx-info {
    padding: 0 0 0 0;
    text-align: left;
    .item {
      margin-bottom: 15px;
      span {
        font-size: 12px;
        color: $--base-color-black;
        &:last-child {
          padding-left: 8px;
        }
      }
    }
  }
}
</style>
